var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 5.00033H3.16667M3.16667 5.00033H16.5M3.16667 5.00033V16.667C3.16667 17.109 3.34226 17.5329 3.65482 17.8455C3.96738 18.1581 4.39131 18.3337 4.83333 18.3337H13.1667C13.6087 18.3337 14.0326 18.1581 14.3452 17.8455C14.6577 17.5329 14.8333 17.109 14.8333 16.667V5.00033H3.16667ZM5.66667 5.00033V3.33366C5.66667 2.89163 5.84226 2.46771 6.15482 2.15515C6.46738 1.84259 6.89131 1.66699 7.33333 1.66699H10.6667C11.1087 1.66699 11.5326 1.84259 11.8452 2.15515C12.1577 2.46771 12.3333 2.89163 12.3333 3.33366V5.00033M7.33333 9.16699V14.167M10.6667 9.16699V14.167",
    stroke: "#768D89",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trashIcon.2691f73ce24e5e891efc4fde69b65e79.svg";
export { ForwardRef as ReactComponent };